import { render, staticRenderFns } from "./SimpleLocalePicker.vue?vue&type=template&id=036c278a&scoped=true&"
import script from "./SimpleLocalePicker.vue?vue&type=script&lang=js&"
export * from "./SimpleLocalePicker.vue?vue&type=script&lang=js&"
import style0 from "./SimpleLocalePicker.vue?vue&type=style&index=0&id=036c278a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "036c278a",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
import { VSlideYTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VBtn,VBtnToggle,VSlideYTransition})


/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1532393991/src/playtient-web-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('036c278a')) {
      api.createRecord('036c278a', component.options)
    } else {
      api.reload('036c278a', component.options)
    }
    module.hot.accept("./SimpleLocalePicker.vue?vue&type=template&id=036c278a&scoped=true&", function () {
      api.rerender('036c278a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SimpleLocalePicker.vue"
export default component.exports